Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    fontBold = _STYLES$useStyles.fontBold,
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing,
    fontSize = _STYLES$useStyles.fontSize,
    lineHeight = _STYLES$useStyles.lineHeight;
  var mobileSizes = bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m]);
  var progressContainer = {
    width: '100%',
    height: mobileSizes ? 26 : 44,
    borderRadius: (0, _styles.getREM)(2.5),
    backgroundColor: COLORS.steam,
    position: 'relative',
    marginBottom: spacing.l,
    overflow: 'hidden',
    backfaceVisibility: 'hidden',
    transform: 'translate3d(0, 0, 0)'
  };
  var progressBar = {
    position: 'absolute',
    backgroundColor: COLORS.cherry,
    height: '100%',
    borderTopLeftRadius: (0, _styles.getREM)(2.5),
    borderBottomLeftRadius: (0, _styles.getREM)(2.5)
  };
  var labelContainer = {
    position: 'absolute'
  };
  var labelText = Object.assign({}, fontSemiBold, {
    letterSpacing: 0,
    color: COLORS.aubergine,
    textAlign: 'center',
    maxWidth: 150
  });
  var innerMarker = {
    color: COLORS.white,
    dotSize: mobileSizes ? 2.3 : 4,
    lineLength: mobileSizes ? 26 : 44,
    gap: 1
  };
  var outerMarker = {
    color: COLORS.cherry,
    dotSize: mobileSizes ? 2.3 : 4,
    gap: 1
  };
  var textCommon = Object.assign({}, fontBold, {
    fontSize: fontSize.m,
    lineHeight: lineHeight.m,
    color: COLORS.aubergine,
    textAlign: 'center'
  });
  var pinkText = Object.assign({}, fontBold, {
    fontSize: fontSize.l,
    lineHeight: lineHeight.l,
    color: COLORS.cherry
  });
  return _reactNative.StyleSheet.create({
    progressContainer: progressContainer,
    progressBar: progressBar,
    labelContainer: labelContainer,
    labelText: labelText,
    innerMarker: innerMarker,
    outerMarker: outerMarker,
    textCommon: textCommon,
    pinkText: pinkText,
    container: {
      position: 'relative',
      marginTop: spacing.xxxl,
      marginBottom: spacing.xxxl
    },
    labelsContainer: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      zIndex: 2
    }
  });
};